export default {
  GetConfig: function (_this, key) {
    return new Promise((resolve) => {
      resolve(window.Config[key])
    })
  },
  SetDocTitle: function (_this) {
    var WebTitle = ''
    this.GetConfig(_this, 'SystemName').then(value => {
      WebTitle = value
    }).then(() => {
      return this.GetConfig(_this, 'Version')
    }).then(value => {
      WebTitle += ' ' + value
    }).then(() => {
      document.title = WebTitle
      _this.control.title = WebTitle.split(' ')
    })
  },
  SetLoading: function (tips) {
    this.RemoveLoading()
    
    const divMask = document.createElement('div')
    divMask.className = 'divMask'
    divMask.id = 'Loading'

    const divInfo = document.createElement('div')
    divInfo.className = 'divInfo'

    const divImage = document.createElement('img')
    divImage.src = '/icon/loading.svg'
    divImage.style.width = '20px'
    divImage.className = 'Loading'

    const divTips = document.createElement('div')
    divTips.className = 'divTips'
    divTips.innerHTML = tips

    divInfo.appendChild(divImage)
    divInfo.appendChild(divTips)
    divMask.appendChild(divInfo)
    document.body.appendChild(divMask)
  },
  RemoveLoading: function () {
    // 为了防止多次加载 Loading 的情况出现
    for (let index = 0; index < 5; index++) {
      const loadingElement = document.getElementById('Loading')
      if (loadingElement) { loadingElement.remove() }
    }
  },
  NetworkErrorDialog: function (_this, callback) {
    this.RemoveLoading()
    _this.control.dialog = {
      state: true,
      title: '网络异常',
      content: '请检查网络连接是否生效, 如网络连接没问题, 大概就是服务器出问题了, 请耐心等候',
      icon: '/icon/warning.svg',
      buttonName: { accept: '朕知道了', cancel: '' },
      accept: () => {
        _this.control.dialog.state = false
        if (callback) { callback() }
      }
    }
  },
  ShowMessage: function (_this, message, icon) {
    _this.control.dialog = {
      state: true,
      title: '提示',
      content: message,
      icon: icon || '/icon/warning.svg',
      buttonName: { accept: '好的', cancel: '' },
      accept: () => {
        _this.control.dialog.state = false
      }
    }
  },
  ShowToast: function (_this, message, type, duration) {
    if (_this.$Toast) {
      _this.$Toast(message, type, duration)
    } else {
      console.warn('Toast plugin not installed')
      // Fallback to dialog if toast not available
      this.ShowMessage(_this, message, type === 'success' ? '/icon/success.svg' : '/icon/warning.svg')
    }
  },
  ApiList: function (_this, name) {
    const aplList = {
      SignIn: '/auth/login/username',
      SignUp: '/auth/register/username',
      SendCode: '/auth/send-code',
      VerifyCode: '/auth/verify-code',
      ChangePwd: '/auth/password/reset',
      Logout: '/auth/logout',
      DeleteAccount: '/auth/user/delete',
      AutoLogin: '/auth/user/info',
      UserInfo: '/auth/user/info',
      // 文档树相关接口
      DocTreeAdd: '/doc/tree/add',
      DocTreeUpdate: '/doc/tree/update',
      DocTreeRemove: '/doc/tree/remove',
      DocTreeMove: '/doc/tree/move',
      DocTreeList: '/doc/tree/list',
      DocTreeSearch: '/doc/tree/search',
      // 旧接口保留或替换
      CreateNote: '/Note/Create',
      NoteList: '/Note/List',
      TagList: '/Note/Tag/List',
      TagUpdate: '/Note/Tag/Update',
      RemoveNote: '/Note/Remove',
      SaveNote: '/doc/content/save',
      GetNote: '/doc/content',
      UploadImage: '/doc/content/upload/image',
      // 回收站接口
      RecycleBinList: '/doc/tree/recycle/list',
      RecycleBinRestore: '/doc/tree/recycle/restore',
      RecycleBinDelete: '/doc/tree/recycle/remove',
      // 版本控制接口
      SaveVersion: '/doc/content/version/save',
      GetVersions: '/doc/content', // 后续拼接 /{urlSlug}/versions
      GetVersionContent: '/doc/content', // 后续拼接 /{urlSlug}/version/{version}
      RestoreVersion: '/doc/content', // 后续拼接 /{urlSlug}/restore/{version}
      // AI 接口
      AiChatStream: '/ai/chat/stream',
      // 分享接口
      ShareEnable: '/doc/tree/share/enable', // /{id}
      ShareDisable: '/doc/tree/share/disable', // /{id}
      ShareUrl: '/doc/tree/share/url', // /{id}
      GetSharedContent: '/doc/content/share', // /{urlSlug}
      // 主题接口
      ThemeList: '/theme/list',
      ThemeUpload: '/theme/upload',
      ThemeEnabled: '/theme/enabled',
      ThemeEnable: '/theme/enable', // /{id}
      ThemeDelete: '/theme', // /{id}
      ThemeShare: '/theme/share', // /{urlSlug}
      // 文本纠错接口
      DocCorrection: '/ai/correction'
    }

    this.GetConfig(_this, 'ApiUrl').then(value => {
      return value + aplList[name]
    })
    return new Promise((resolve) => {
      this.GetConfig(_this, 'ApiUrl').then(value => {
        resolve(value + aplList[name])
      })
    })
  }
}
